import { RailingColorElement } from './railingColorElement';

export class RailingColorMap {
  type;
  railingElements: { [key: string]: RailingColorElement };
  selectedUniformColor;

  constructor(railingType: string, railingElements: object) {
    this.type = railingType;
    this.setRailingElements(railingElements);
    this.selectedUniformColor = false;
  }

  setRailingElement(railingElementType: string, railingElementDefaultColor: string) {
    this.railingElements[railingElementType] = new RailingColorElement(railingElementDefaultColor);
    this.railingElements[railingElementType]['type'] = railingElementType;
  }

  setRailingElements(railingElements: object) {
    this.railingElements = <{ [key: string]: RailingColorElement }>new Object();

    for (let element in railingElements) {
      this.railingElements[element] = new RailingColorElement(railingElements[element]);
      this.railingElements[element]['type'] = element;
      this.setRailingElement(element, railingElements[element]);
    }
  }

  setSelectedUniformColor(color) {
    this.selectedUniformColor = color;
  }
}



// WEBPACK FOOTER //
// ./src/app/custom/railingColorMap.ts